import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';

export const NotificationFooter = () => (
  <FlexColumn className={style.footer} gap={Gap.Space8}>
    <Text className={style.title} element='div' textType={TextType.Paragraph} value={messages.title} />
    <Text className={style.description} element='div' textType={TextType.Caption} value={messages.description} />
  </FlexColumn>
);
